






















































































import { DataProxy } from 'apollo-cache';
import * as R from 'ramda';
import Vue from 'vue';

import { Product } from '@/core/entity';
import { productFragment, searchProductQL } from './graphql';

import ProductForm from './Form.vue';

interface ProductEdge {
  node: Product;
}

interface SearchResult {
  edges: ProductEdge[];
}

export default Vue.extend({
  components: {
    'form-product': ProductForm,
  },

  data() {
    const productId = this.$route.params.product_id;
    return {
      country: 'my',
      isDrawerVisible: productId ? true : false,
      loading: false,
      products: [] as Product[],
      query: '',
    };
  },

  computed: {
    productId(): string {
      return this.$route.params.product_id;
    },

    drawerTitle(): string {
      return this.productId ? 'Edit product' : 'Create a new product';
    },
  },

  watch: {
    productId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    async handleSearch() {
      const { country, query } = this;
      if (query.length < 3) {
        this.$message.error(`Product name must be at least 3 characters.`);
        return;
      }

      try {
        this.loading = true;

        const result = await this.$apollo.query({
          query: searchProductQL,
          variables: { country, query },
        });

        if (result.data.searchResult) {
          this.products = R.map((e) => e.node, result.data.searchResult
            .edges as ProductEdge[]);
        }
      } catch (err) {
        console.error(err); // tslint:disable-line no-console
        this.$message.error(`Unable to search products.`);
      } finally {
        this.loading = false;
      }
    },

    handleSubmit(form: {
      brand: string;
      category: string;
      country: string;
      desProductId: string | null;
      name: string;
      photoUrl: string | null;
    }) {
      const { productId } = this;
      const payload = {
        brand: form.brand,
        category: form.category,
        country: form.country,
        desProductId: form.desProductId,
        name: form.name,
        photoUrl: form.photoUrl,
      };

      if (productId) {
        // edit product
        this.$coreApp.product.update(
          productId,
          payload,
          this.presenter('Product updated.', 'Unable to update product:', true),
          { name: 'ListProductPageProduct', query: productFragment },
          this.updater,
        );
      } else {
        // create product
        this.$coreApp.product.create(
          payload,
          this.presenter('Product created.', 'Unable to create product:', true),
          { name: 'ListProductPageProduct', query: productFragment },
          this.updater,
        );
      }
    },

    hideDrawer() {
      this.isDrawerVisible = false;

      // @ts-ignore clear method is available but Typescript is not picking it up correctly
      this.$refs.productForm.clear();
      if (this.productId) {
        this.$router.back();
      }
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },

    presenter(success: string, failure: string, isNew: boolean) {
      return (err: Error | null, result: Product | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);

          if (isNew) {
            this.hideDrawer();
          } else {
            this.$router.push({ name: 'product.list' });
          }
        }
      };
    },

    updater(
      store: DataProxy,
      res: { data: { newProduct?: Product; updateProduct?: Product } },
    ) {
      const product = (res.data.updateProduct ||
        res.data.newProduct) as Product;

      const isNew = res.data.newProduct;
      const products: Product[] = this.products;
      if (isNew) {
        this.products = R.insert(0, product, products);
      } else {
        const idx = R.findIndex(R.propEq('id', product.id), products);
        if (idx !== -1) {
          this.products = R.update(idx, product, products);
        }
      }
    },
  },
});
